<script setup lang="ts">

</script>

<template>
    <v-chip
        variant="flat"
        color="#B8E2C2"
        size="x-small"
        class="text-green-darken-4 ml-2 px-2 text-caption"
    >
        Completed
    </v-chip>
</template>

<style scoped>

</style>
